import image from "./spinner.gif";
export default ({message, loading}) => (
  <div id="loading">
    <div>
      {loading && <img id="loading-image" src={image} alt="Application is loading..." />}
      <h3>{message}</h3>
    </div>
  </div>
);
